(function () {
  if (window.dmHomeLoaded) return;
  window.dmHomeLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Fade-up on scroll
  function initReveal(root) {
    var items = root.querySelectorAll('.dm-reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  // Three-row marquee; odd rows run left, even rows run right
  function initTicker(root) {
    root.querySelectorAll('[data-dm-ticker-track]').forEach(function (track) {
      if (track.dataset.dmRunning) return;
      track.dataset.dmRunning = '1';
      if (reduceMotion) return;
      var speed = parseFloat(track.dataset.speed) || 0.6;
      var dir = track.dataset.direction === 'right' ? 1 : -1;
      var pos = 0;
      var started = false;
      function step() {
        if (!track.isConnected) return;
        var half = track.scrollWidth / 2;
        if (!started) { if (dir === 1) pos = -half; started = true; }
        pos += dir * speed;
        if (dir === -1 && Math.abs(pos) >= half) pos = 0;
        if (dir === 1 && pos >= 0) pos = -half;
        track.style.transform = 'translateX(' + pos + 'px)';
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  // Drag-to-compare before/after
  function initCompare(root) {
    root.querySelectorAll('[data-dm-compare]').forEach(function (box) {
      if (box.dataset.dmReady) return;
      box.dataset.dmReady = '1';
      var handle = box.querySelector('[data-dm-handle]');
      var after = box.querySelector('[data-dm-after]');
      if (!handle || !after) return;
      var dragging = false;
      function setPos(clientX) {
        var rect = box.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        handle.style.left = pct + '%';
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      }
      box.addEventListener('pointerdown', function (e) { dragging = true; setPos(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('pointerup', function () { dragging = false; });
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(handle.style.left) || 50;
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var next = Math.max(0, Math.min(100, current + (e.key === 'ArrowLeft' ? -5 : 5)));
        handle.style.left = next + '%';
        after.style.clipPath = 'inset(0 0 0 ' + next + '%)';
        handle.setAttribute('aria-valuenow', Math.round(next));
      });
    });
  }

  // One-open-at-a-time accordion
  function initFaq(root) {
    root.querySelectorAll('[data-dm-faq]').forEach(function (list) {
      if (list.dataset.dmReady) return;
      list.dataset.dmReady = '1';
      var items = list.querySelectorAll('.dm-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.dm-faq__q');
        var panel = item.querySelector('.dm-faq__a');
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            other.querySelector('.dm-faq__q').setAttribute('aria-expanded', 'false');
            other.querySelector('.dm-faq__a').style.maxHeight = null;
          });
          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });
    });
  }

  // "Get it between Monday, September 28th and Tuesday, September 29th."
  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  function formatDay(date) {
    var weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
    var month = date.toLocaleDateString('en-US', { month: 'long' });
    return weekday + ', ' + month + ' ' + ordinal(date.getDate());
  }
  function initDelivery(root) {
    root.querySelectorAll('[data-dm-delivery]').forEach(function (el) {
      var out = el.querySelector('.dm-delivery__text');
      var min = parseInt(el.dataset.min, 10) || 0;
      var max = parseInt(el.dataset.max, 10) || min;
      var start = new Date();
      var end = new Date();
      start.setDate(start.getDate() + min);
      end.setDate(end.getDate() + max);
      var escape = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
      out.innerHTML = escape(el.dataset.text || '')
        .replace('[start]', '<strong>' + formatDay(start) + '</strong>')
        .replace('[end]', '<strong>' + formatDay(end) + '</strong>');
    });
  }

  // Keep the COD button on the variant the shopper picked (Dawn puts it in ?variant=)
  function initCod(root) {
    root.querySelectorAll('.dm-cod-form').forEach(function (form) {
      if (form.dataset.dmReady) return;
      form.dataset.dmReady = '1';
      form.addEventListener('submit', function () {
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        var section = form.closest('section') || document;
        var mainInput = section.querySelector('.product-variant-id, form[id^="product-form-"] input[name="id"]');
        var id = fromUrl || (mainInput && mainInput.value);
        if (id) form.querySelector('input[name="id"]').value = id;
      });
    });
  }

  // Flash-sale timer: counts to a fixed end (UAE time, UTC+4) or to UAE midnight
  var UAE_OFFSET_MS = 4 * 3600 * 1000;
  function nextUaeMidnight() {
    var nowUae = new Date(Date.now() + UAE_OFFSET_MS);
    return Date.UTC(nowUae.getUTCFullYear(), nowUae.getUTCMonth(), nowUae.getUTCDate() + 1) - UAE_OFFSET_MS;
  }
  function parseUaeDate(text) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/.exec((text || '').trim());
    if (!m) return null;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59)) - UAE_OFFSET_MS;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdown(root) {
    root.querySelectorAll('[data-dm-countdown]').forEach(function (el) {
      if (el.dataset.dmReady) return;
      el.dataset.dmReady = '1';
      var fixed = el.dataset.mode === 'fixed';
      var end = fixed ? parseUaeDate(el.dataset.end) : nextUaeMidnight();
      if (end === null) { el.hidden = true; return; }
      var h = el.querySelector('[data-h]');
      var m = el.querySelector('[data-m]');
      var s = el.querySelector('[data-s]');
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          if (!fixed) { end = nextUaeMidnight(); left = end - Date.now(); }
          else {
            if (el.dataset.hideEnded === 'true') { el.hidden = true; return; }
            left = 0;
          }
        }
        var total = Math.floor(left / 1000);
        h.textContent = pad(Math.floor(total / 3600));
        m.textContent = pad(Math.floor((total % 3600) / 60));
        s.textContent = pad(total % 60);
        if (left > 0 && el.isConnected) setTimeout(tick, 1000 - (Date.now() % 1000));
      }
      tick();
    });
  }

  function init(root) {
    initCountdown(root);
    initReveal(root);
    initTicker(root);
    initCompare(root);
    initFaq(root);
    initDelivery(root);
    initCod(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
